var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getFieldComponent(_vm.field.type),{tag:"component",attrs:{"row":_vm.row,"field":_vm.field,"value":_vm.row[`field_${_vm.field.id}`],"selected":false,"state":{},"read-only":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }